<template>
  <div class="yx-datainit-buliding-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 学习资料</template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
        @edit="goto"
        @delete="pageDel"
      >
      </c-table>
    </el-card>
    <!-- 编辑弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
      :lock-scroll="false"
    >
      <!-- <c-form
              v-model="handleData"
              ref="cForm"
              :formRules="formRules"
              :formItems="formItems"
              @submit="submit"
              @resetFields="resetFields"
            >
            </c-form> -->
      <el-form
        size="medium"
        :model="handleData"
        ref="cForm"
        :rules="formRules"
        label-width="100px"
      >
        <el-form-item label="资料名称" prop="name">
          <el-input v-model="handleData.name"></el-input>
        </el-form-item>
        <el-form-item label="上传资料" prop="url">
          <el-input v-model="handleData.url" v-show="false"></el-input>
          <el-upload
            class="upload-demo"
            :limit="1"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :http-request="customUpload"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">
                          只能上传jpg/png文件，且不超过500kb
                        </div> -->
          </el-upload>
        </el-form-item>

        <el-form-item label-width="0">
          <div style="text-align: center; padding-top: 20px">
            <el-button type="primary" class="leave-btn" @click="submitForm()"
              >保存
            </el-button>
            <el-button type="primary" class="leave-btn" @click="cancel" plain
              >取消
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { guid } from "@/libs/tools.js";
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/learningMaterials";
import mUpload from "@/mixins/MUpload.js";
import {
  getOrgOptions,
  getUserOptions,
  getLinkOptions,
} from "@/libs/searchSelect.js";

let mPage = MPage({
  pagePath: "/welcome-forecast/study/listPage",
  pageDelPath: "/welcome-forecast/study",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/welcome-forecast/study",
  handleInsertPath: "/welcome-forecast/study/save",
  handleUpdatePath: "/welcome-forecast/study/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle, mUpload],
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      SUCCESS_CODE: "",
      searchItems,
      tableColumns,
      formItems,
      formRules,
      idList: [],
      title: "",
      dialogFormVisible: false,
      defaultHandleData: {
        name: "",
        fileName: "",
        fileSize: "",
        url: "",
      },
      fileList: [],
      dialogVisible: false,
      marker: null,
      isLoading: false,
    };
  },
  created() {
    this.handleData = Object.assign({}, this.defaultHandleData);
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    // getOrgOptions(this, { type: "college" }, null, 2);
    // getUserOptions(this, null, 4);
    // getLinkOptions(this, null, 3);
  },
  beforeMount() {},
  mounted() {},
  methods: {
    goto(data) {
      this.handleData = Object.assign({}, this.defaultHandleData);
      this.fileList = [];
      this.dialogFormVisible = true;
      let id = data.id;
      if (id) {
        this.handleGet(id);
        this.title = "编辑";
      } else {
        this.title = "新增";
      }
    },
    handleGetAfterFn(data) {
      this.fileList = [{ url: data.url, name: data.fileName }];
      console.log(this.fileList);
      return data;
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    cancel() {
      this.dialogFormVisible = false;
      this.resetFields();
    },
    submitForm() {
      this.$refs["cForm"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleAfterFn() {
      this.fileList = [];
      this.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    resetFields() {
      this.fileList = [];
      this.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      this.fileList = [];
      this.$refs.cForm.resetFields();
    },
    // 自定义上传方法
    customUpload(e) {
      console.log(e);
      let self = this;
      var file = e.file;
      var fileName = guid();
      this.obsUpload(file, fileName, this.afterObsUpload);
    },
    afterObsUpload(obsUrl, file) {
      // this.fileList = [].push(file);
      this.handleData.url = obsUrl;
      this.handleData.fileName = file.name;
      this.handleData.fileSize = file.size;
    },
    // obsUpload(file, key, callback) {
    //   let self = this;
    //   this.isLoading = true;
    //   var ak = self.$OBS_AK;
    //   var sk = self.$OBS_SK;
    //   var server = self.$OBS_SERVER;
    //   var bucket = self.$OBS_BUCKET;
    //   let prefix = self.$OBS_PREFIX;
    //   var obsClient = new ObsClient({
    //     access_key_id: ak,
    //     secret_access_key: sk,
    //     server: server,
    //     timeout: 60 * 5,
    //   });
    //   // put objects
    //   obsClient
    //     .putObject({
    //       Bucket: bucket,
    //       Key: key,
    //       Metadata: { property: "property-value" },
    //       SourceFile: file,
    //     })
    //     .then(function (result) {
    //       if (result.CommonMsg.Status == 200) {
    //         console.log(result);
    //         // 上传成功后的操作
    //         callback && callback(file, key);
    //         self.fileList = [].push(file);
    //         let obsUrl = prefix + key;
    //         self.handleData.url = obsUrl;
    //         self.handleData.fileName = file.name;
    //         self.handleData.fileSize = file.size;
    //         // console.log(self.pictureUrl);
    //       }
    //       self.isLoading = false;
    //     })
    //     .catch(function (err) {
    //       self.isLoading = false;
    //       this.$message.error(err);
    //     });
    // },
    handlePreview(file) {
      console.log(file);
      window.open(this.handleData.url, "_blank");
    },
    handleRemove(file, fileList) {
      console.log(file);
      this.fileList = [];
      this.handleData.url = "";
    },
    // 超出提示
    handleExceed() {
      this.$message.warning(
        `当前限制选择 1 个文件，如需更换文件请删除下方文件列表中的文件`
      );
    },
  },
};
</script>


